import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { IDataPoint } from "@skills-app/models/skillStatistics";
import {
  SkillStatisticsApiActions,
  SkillStatisticsPageActions,
} from "@skills-app/skill-statistics/actions";

export interface ISkillStatisticsState {
  locations: string[];
  data: IDataPoint[];
  locationsLoading: boolean;
  graphLoading: boolean;
}

const initialState: ISkillStatisticsState = {
  locations: [],
  data: [],
  locationsLoading: false,
  graphLoading: false,
};

export const reducer = createReducer(
  initialState,

  on(SkillStatisticsPageActions.requestLocations, (state) => ({
    ...state,
    locationsLoading: true,
  })),

  on(SkillStatisticsPageActions.requestLocationsSuccess, (state, action) => ({
    ...state,
    locations: action.locations,
    locationsLoading: false,
  })),

  on(SkillStatisticsApiActions.requestGraphData, (state) => ({
    ...state,
    graphLoading: true,
  })),

  on(SkillStatisticsApiActions.requestGraphDataSuccess, (state, action) => ({
    ...state,
    data: action.data,
    graphLoading: false,
  })),
);

export const getSkillStatisticsState =
  createFeatureSelector<ISkillStatisticsState>("skillStatistics");

export const getLocations = createSelector(
  getSkillStatisticsState,
  (state) => state.locations,
);

export const getGraphData = createSelector(
  getSkillStatisticsState,
  (state) => state.data,
);

export const getLocationsLoading = createSelector(
  getSkillStatisticsState,
  (state) => state.locationsLoading,
);

export const getGraphLoading = createSelector(
  getSkillStatisticsState,
  (state) => state.graphLoading,
);
